import config from '../../../app/config';
import axios from 'axios';

export class ReportsAPI {
    static DefaultApiName = 'reportsUrl';

    static docReport(filter, signal = null, api = ReportsAPI.DefaultApiName) {
        return new Promise(async function (resolve, reject) {
            if (config.hasOwnProperty(api)) {
                let url = `${(config[api].endsWith('/') ? config[api] : config[api] + '/')}doc_report_studies`;
                axios.post(url, filter, {signal, stopRetry: true}).then((response) => {
                    //console.log("tableName: " + tableName, response.data);
                    resolve(response);
                }).catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
            } else {
                reject(`incorrect api name [${api}], missing in config`);
            }
            // TODO: error handling ???
        });
    }

    static auditReport(filter, signal = null, api = ReportsAPI.DefaultApiName) {
        return new Promise(async function (resolve, reject) {
            if (config.hasOwnProperty(api)) {
                let url = `${(config[api].endsWith('/') ? config[api] : config[api] + '/')}audit_report`;
                axios.post(url, filter, {signal, stopRetry: true}).then((response) => {
                    //console.log("tableName: " + tableName, response.data);
                    resolve(response);
                }).catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
            } else {
                reject(`incorrect api name [${api}], missing in config`);
            }

            // TODO: error handling ???
        });
    }

    static docReportSum(filter, signal = null, api = ReportsAPI.DefaultApiName) {
        return new Promise(async function (resolve, reject) {
            if (config.hasOwnProperty(api)) {
                let url = `${(config[api].endsWith('/') ? config[api] : config[api] + '/')}stat_report`;
                axios.post(url, filter, {signal, stopRetry: true}).then((response) => {
                    //console.log("tableName: " + tableName, response.data);
                    resolve(response);
                }).catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
            } else {
                reject(`incorrect api name [${api}], missing in config`);
            }

            // TODO: error handling ???
        });
    }

    static userLastLogin(filter, signal = null, api = ReportsAPI.DefaultApiName) {
        return new Promise(async function (resolve, reject) {
            if (config.hasOwnProperty(api)) {
                let url = `${(config[api].endsWith('/') ? config[api] : config[api] + '/')}users_last_login`;
                axios.post(url, filter, {signal, stopRetry: true}).then((response) => {
                    //console.log("tableName: " + tableName, response.data);
                    resolve(response);
                }).catch(error => {
                    if (error?.message !== 'canceled') {
                        reject(error);
                    }
                });
            } else {
                reject(`incorrect api name [${api}], missing in config`);
            }
            // TODO: error handling ???
        });
    }
}
